import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { ContentItemHomeStoryPackageLead } from "scmp-app/components/content/content-item-render/variants/home-story-package-lead";
import { ContentItemHomeStoryPackageTail } from "scmp-app/components/content/content-item-render/variants/home-story-package-tail";
import { EntityLink } from "scmp-app/components/entity-link";
import { HomeFollowButton } from "scmp-app/components/home/follow-button";

export const StyledContentItemHomeStoryPackageLead = styled(ContentItemHomeStoryPackageLead)``;
export const StyledContentItemHomeStoryPackageTail = styled(ContentItemHomeStoryPackageTail)``;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  inline-size: 100%;
`;

export const SCMPSeriesLink = styled(BaseLink)`
  grid-area: topic-name-follow;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  inline-size: fit-content;

  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;

  opacity: 0.5;
`;

export const TopicNameEntityLink = styled(EntityLink)``;

export const TopicNameBaseLink = styled(BaseLink)``;

export const TopicName = styled.div`
  color: rgba(0, 0, 0, 0.5);
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;
  white-space: pre-line;
`;

export const StyledTopicFollowButton = styled(HomeFollowButton)`
  flex-shrink: 0;

  margin-inline-start: 12px;
`;

export const Articles = styled.div`
  grid-area: leading-article;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;

  inline-size: 100%;
  margin-block: 16px 20px;
  ${theme.breakpoints.up("tablet")} {
    margin-block: 16px 24px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  margin: 0;
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  inline-size: auto;
  margin-inline-end: 8px;
`;

type TabProps = {
  $isActive: boolean;
};

export const Tab = styled.div<TabProps>`
  display: flex;

  margin-block-end: 1px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 140%; /* 33.6px */

  border: 1px solid transparent;
  border-color: ${props => (props.$isActive ? "#000" : "transparent")};
  border-radius: 100px;

  background: rgba(69, 137, 255, 0.1);

  cursor: pointer;
`;
